import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "user-container d-flex justify-content order-0" }
const _hoisted_2 = { class: "user-container__info d-flex flex-column justify-content-between" }
const _hoisted_3 = { class: "user-container__info__name font-weight-600" }
const _hoisted_4 = { class: "user-container__info__email font-big" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "user-container__logo" }, [
        _createElementVNode("img", {
          src: "/assets/images/Group-user-pic.png",
          alt: "user image"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", _hoisted_3, [
          (_ctx.store.state.customer.company_name)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.store.state.customer.company_name), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.store.state.customer.first_name ?? '') + " " + _toDisplayString(_ctx.store.state.customer.last_name ?? ''), 1)
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.store.state.customer.email), 1)
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "hr-line m-2 mb-3 order-1" }, null, -1))
  ], 64))
}